import { createContext, useContext, useState, useEffect } from "react";

// Supabase
import supabase from "../supabaseClient";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [teamId, setTeamId] = useState(null);
  const [profileId, setProfileId] = useState(null);

  const emailRedirectTo = "https://app.getkoubi.com/dashboard";

  useEffect(() => {
    const getSession = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      setUser(session?.user ?? null);
      setLoading(false);
    };

    getSession();

    const { data: listener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        setUser(session?.user ?? null);
        setLoading(false);
      }
    );

    return () => {
      // listener?.unsubscribe();
    };
  }, []);

  useEffect(() => {
    const fetchTeamId = async () => {
      if (user) {
        const { data: accountData, error: accountError } = await supabase
          .from("accounts")
          .select("team_id")
          .eq("user_id", user.id)
          .single();

        if (accountError) {
          console.error("Error fetching account:", accountError);
        } else {
          setTeamId(accountData.team_id);
        }
      }
    };

    fetchTeamId();
  }, [user]);

  useEffect(() => {
    const fetchProfileId = async () => {
      if (user) {
        const { data: profileData, error: profileError } = await supabase
          .from("profiles")
          .select("id")
          .eq("account_id", user.id)
          .single();

        if (profileError) {
          console.error("Error fetching profile:", profileError);
        } else {
          setProfileId(profileData.id);
        }
      }
    };

    fetchProfileId();
  }, [user]);

  const value = {
    // Sign up with email and password
    signUp: (
      email,
      password,
      phone,
      name,
      countryIso,
      locale,
      stripeId,
      subscriptionId
    ) => {
      return supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            phone,
            name,
            country_iso: countryIso,
            locale,
            stripe_id: stripeId,
            subscription_id: subscriptionId,
          },
          emailRedirectTo: emailRedirectTo,
        },
      });
    },

    // Sign in with email and password
    signIn: (email, password) => {
      return supabase.auth.signInWithPassword({
        email,
        password,
      });
    },

    // Sign in with OTP
    signInWithOtp: (email) =>
      supabase.auth.signInWithOtp({
        email,
        options: {
          shouldCreateUser: false,
          emailRedirectTo: emailRedirectTo,
        },
      }),
    signOut: () => supabase.auth.signOut(),

    // Update the password
    setNewPassword: (newPassword) => {
      return supabase.auth.updateUser({
        password: newPassword,
      });
    },

    user,
    teamId,
    profileId,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
